import { QueryStatus } from 'react-query';
import {
  useExportAudio,
  useExportVideo,
} from 'pages/TranscriptEditorPage/state';
import useExportTranscript from 'pages/TranscriptEditorPage/state/useExportTranscript';
import { queryStatusResolver } from 'state/utils';

export interface UseShare {
  exportAudio: ReturnType<typeof useExportAudio>['exportAudio'];
  exportVideo: ReturnType<typeof useExportVideo>['exportVideo'];
  exportTranscript: ReturnType<typeof useExportTranscript>['exportTranscript'];
  status: QueryStatus;
  progress: number | undefined;
}

const useShare = (): UseShare => {
  const {
    data: exportAudioData,
    exportAudio,
    status: audioStatus,
  } = useExportAudio();
  const {
    data: exportVideoData,
    exportVideo,
    status: videoStatus,
  } = useExportVideo();
  const { exportTranscript, status: transcriptStatus } = useExportTranscript();

  return {
    exportAudio,
    exportVideo,
    exportTranscript,
    status: queryStatusResolver([audioStatus, videoStatus, transcriptStatus]),
    progress: exportAudioData?.progress ?? exportVideoData?.progress,
  };
};

export default useShare;
